"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable react/function-component-definition */
/* eslint-disable react/require-default-props */
const react_1 = __importDefault(require("react"));
const Textarea_scss_1 = __importDefault(require("./Textarea.scss"));
const Textarea = ({ inputKey, state: { error, value }, onInput, placeholder = '', maxLength = Infinity, }) => {
    const changeHandler = (e) => {
        onInput(inputKey, e.target.value);
    };
    return (react_1.default.createElement("textarea", { value: value, className: Textarea_scss_1.default.editor, placeholder: placeholder, onChange: changeHandler, maxLength: maxLength }));
};
exports.default = Textarea;
